import React from "react";
import { PlusOutlined,PrinterOutlined } from "@ant-design/icons";
import {
  Drawer,
  Button,
  PageHeader,
} from "antd";
import { useState } from "react";




import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";

import { ADD_MODE, DEFAULT_MASTER_DRAWER_WIDTH } from "../../utility/Constants";
import AccountList from "../../components/masters/account/AccountList";
import AccountEntry from "../../components/masters/account/AccountEntry";
import DrawableCloseIcon from "../../components/common/DrawableCloseIcon";
import { Link, useNavigate } from "react-router-dom";



const Account = () => {
  let navigate = useNavigate();
    const [visible, setVisible] = useState(false);
  const [accountAddData, setAccountAddData] = useState({
    /*
    id: 0,
    gstDescription: '',
    gstType: '',
    rate: '',
    accountId: '',
    usedfor: '',
    mode: ADD_MODE,
*/

    id: 0,
    account_name: '',
    opening_balance:0,
    group_master_id: '',
    is_special: 'N',
    is_closingstk: 'N',
    mode: ADD_MODE,

    hsn_code:'',
    gstin:'',
    state:'',
    address:'',

  });



  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };


  function changeLocation(placeToGo) {
    navigate(placeToGo, { replace: true });
    window.location.reload();
}
const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
}

  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Account"
          subTitle=""
          extra={[
            
            <Button key="1" className="custom-button-white" shape="round" onClick={() => openInNewTab("http://btaportal.in/custom/report/account/printpdf")}>
              <PrinterOutlined /> Print Account
            </Button>,
        
            <Button key="2" className="custom-button-white" shape="round" onClick={showDrawer}>
              <PlusOutlined /> Add
            </Button>,
          ]}
        ></PageHeader>

        <Drawer
          title="Add new ledger"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose={true}
          closeIcon = {<><DrawableCloseIcon /></>}
        >
          <AccountEntry data={accountAddData} onDrawerClose={onClose} />
        </Drawer>

        <div className="tableView">
          <div className="form-content">
            <AccountList />
          </div>
        </div>

      </div>
    </div>
  )
}

export default Account